import { Controller } from "@hotwired/stimulus"

// Switch (toggle). Mantém `aria-checked` em sincronia com o estado `:checked`
// do checkbox nativo subjacente. Necessário porque um input[type=checkbox] com
// role="switch" NÃO atualiza aria-checked automaticamente — SRs leriam o estado
// inicial pra sempre sem isso.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.sync()
  }

  sync() {
    this.inputTarget.setAttribute("aria-checked", String(this.inputTarget.checked))
  }
}
